export const deleteFileFromQuizQuestion = (payload?: any) => ({
    type: "@saga/DELETE_FILE_FROM_QUIZ_QUESTION",
    payload
});

